/* eslint-disable react/prop-types */
import React from 'react';
import cn from 'classnames';
import { getDateWithFormat, getMomentDate } from 'util/date';
import { RESULT_LABEL } from 'views/ProductDetail/Sections/ComplianceData/components/ComplianceTable/utils';
import classes from './AddCDModal.module.scss';

export const ResultText = ({ text }) => {
  if (!text) return <span style={{ color: '#232b3a' }}>/</span>;
  const lowerText = text.toLowerCase();
  return (
    <span
      className={cn(classes.resultText, {
        [classes.pass]: lowerText === 'pass' || lowerText === 'passed',
        [classes.fail]: lowerText === 'fail' || lowerText === 'failed',
      })}>
      {text}
    </span>
  );
};

export const TestDataHeader = () => {
  return (
    <>
      <span>Export Market</span>
      <span>Test Item</span>
      <span>Citation</span>
      <span>Report ID</span>
      <span>Issue Party</span>
      <span>Expiry Date</span>
      <span>Result</span>
    </>
  );
};
export const CertificateDataHeader = () => {
  return (
    <>
      <span>Type</span>
      <span>Score / Overall Rating</span>
      <span>Issue Party</span>
      <span>Expiry Date</span>
      {/* <span>Result</span> */}
    </>
  );
};
export const OtherDataHeader = () => {
  return (
    <>
      <span>Type</span>
      <span>Name</span>
      <span>Description</span>
      <span>Issue Party</span>
      <span>Expiry Date</span>
      <span>Result</span>
    </>
  );
};
export const TestDataRow = ({ data }) => {
  const today = getMomentDate('', true).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const tMomentVal = getMomentDate(data?.expiryDate);
  const isExpired =
    !!tMomentVal &&
    tMomentVal
      .clone()
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .isBefore(today);
  return (
    <>
      <span>{data?.countryList?.name || '-'}</span>
      <span>{data?.testItem?.name || '-'}</span>
      <span>{data?.citation?.name || '-'}</span>
      <span>{data?.reportId || '-'}</span>
      <span>{data?.serviceProvider?.name || '-'}</span>
      <span
        style={{
          color: isExpired ? 'red' : undefined,
        }}>
        {getDateWithFormat(data?.expiryDate, 'DD MMM YYYY') || '-'}
      </span>
      <ResultText text={RESULT_LABEL[data?.result] || data?.result} />
    </>
  );
};
export const CertificateDataRow = ({ data }) => {
  const today = getMomentDate('', true).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const tMomentVal = getMomentDate(data?.expiryDate);
  const isExpired =
    !!tMomentVal &&
    tMomentVal
      .clone()
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .isBefore(today);
  return (
    <>
      <span>{data?.certificateType?.name || '-'}</span>
      <span>{data?.customCertificateScore?.name || '-'}</span>
      <span>{data?.customIssueParty?.name || '-'}</span>
      <span
        style={{
          color: isExpired ? 'red' : undefined,
        }}>
        {getDateWithFormat(data?.expiryDate, 'DD MMM YYYY') || '-'}
      </span>
      {/* <ResultText text={data?.status} /> */}
    </>
  );
};
export const OtherDataRow = ({ data }) => {
  const today = getMomentDate('', true).set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
  const tMomentVal = getMomentDate(data?.expiryDate);
  const isExpired =
    !!tMomentVal &&
    tMomentVal
      .clone()
      .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
      .isBefore(today);
  return (
    <>
      <span>{data?.customComplianceOtherDataType?.name || '-'}</span>
      <span>{data?.name || '-'}</span>
      <span>{data?.description || '-'}</span>
      <span>{data?.customIssueParty?.name || '-'}</span>
      <span
        style={{
          color: isExpired ? 'red' : undefined,
        }}>
        {getDateWithFormat(data?.expiryDate, 'DD MMM YYYY') || '-'}
      </span>
      <ResultText text={RESULT_LABEL[data?.result] || data?.result} />
    </>
  );
};
